import { NAME } from './constants';

export const INIT = `${NAME}/INIT`;
export const RESET = `${NAME}/RESET`;
export const SAVE = `${NAME}/SAVE`;
export const CALL = `${NAME}/CALL`;
export const MARK_AS_PAID = `${NAME}/MARK_AS_PAID`;
